export const FullScreenLoader = () => (
  <div data-testid="full-screen-loader" className="what-app h-screen grid place-items-center">
    <div className="flex items-baseline gap-2">
      <span className="font-display text-3xl font-extrabold tracking-tight text-white">WHAT?</span>
      <span className="what-dot animate-pulse" />
    </div>
  </div>
);
